export default __webpack_public_path__ + "static/media/group3.09157b3a.png";